<template>
  <div class="v-view chart-view a-fadeIn flx-center" :style="{ height: span * 33.33 + '%' }">
    <div class="v-title">{{ title }}

    </div>

    <v-chart v-if="pieData.length > 0" ref="chart" class="cv-chart" :options="pieOption" @mouseover="onMouseOver"
      @globalout="onGlobalOut" autoresize></v-chart>
    <div v-else class="cv-nodata">暂无数据!</div>
    <div class="health" v-if="elder && elder.length > 0">
      <div class="sec-title">空巢独居老人</div>
      <div @click="toElderDetail('第一类人数')">{{ elder[8].Name }}：<span class="">{{ elder[8].Value }}</span></div>
      <div @click="toElderDetail('第二类人数')">{{ elder[9].Name }}：<span>{{ elder[9].Value }}</span></div>
      <div @click="toElderDetail('第三类人数')">{{ elder[10].Name }}：<span>{{ elder[10].Value }}</span></div>
      <div @click="toElderDetail('第四类人数')">{{ elder[11].Name }}：<span class="">{{ elder[11].Value }}</span></div>
      <div @click="toElderDetail('第五类人数')">{{ elder[12].Name }}：<span>{{ elder[12].Value }}</span></div>
      <div @click="toElderDetail('第六类人数')">{{ elder[13].Name }}：<span>{{ elder[13].Value }}</span></div>
    </div>
    <div class="health" v-if="elder && elder.length > 0">
      <div class="sec-title">
        健康数据
      </div>
      <div @click="toElderDetail('体检')">体检总人数：<span class="">{{ elder[5].Value }}</span></div>
      <div @click="toElderDetail('高血压')">高血压人数：<span>{{ elder[6].Value }}</span></div>
      <div @click="toElderDetail('高血糖')">高血糖人数：<span>{{ elder[7].Value }}</span></div>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Mixins } from '../minix/index'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/legend'

export default {
  name: 'AllElderAge',
  mixins: [Mixins],
  computed: {
    ...mapGetters(['cid']),
    chart() {
      return this.$refs.chart && this.$refs.chart['chart']
    },
  },
  props: {
    type: {
      type: String,
      default: 'pie',
    },
    span: {
      type: Number,
      default: 1,
    },
    title: {
      type: String,
      default: '年龄段占比',
    },
  },
  watch: {
    pieData(data) {
      this.pieOption.dataset.source = data.map((item) => ({
        name: item.Name,
        value: item.Value,
        value2: item.Value2,
      }))
      this.$nextTick(() => {
        if (this.chart && !this.pieInterval) this.startAnimation()
      })
    },
  },
  data() {
    return {
      dataIndex: -1,
      pieInterval: null,
      pieOption: {
        color: ['#00c96a', '#00afe3', '#e7df00', '#ff2538', '#44A08D', '#F8FFAE', '#B06AB3'],
        legend: {
          show: false,
          top: 'center',
          left: '0%',
          orient: 'vertical',
          itemWidth: 20,
          itemHeight: 10,
          textStyle: {
            color: '#fff',
            fontSize: 12,
          },
        },
        dataset: {
          source: [],
        },
        series: [
          {
            type: 'pie',
            name: '服务老人年龄段分布',
            radius: ['70%', '85%'],
            center: ['50%', '50%'],
            label: {
              show: false,
              padding: [10, 5],
              position: 'center',
              formatter: function (params) {
                return params.data.name + "\n" + params.data.value2 + "人\n" + params.data.value + '%'
              },
              backgroundColor: 'rgba(0,0,0,0.3)',
              emphasis: {
                show: true,
                fontSize: 15,
              },
            },
            itemStyle: {
              shadowBlur: 10,
              shadowColor: '#0096ff',
            },
            encode: {
              itemName: 'name',
              value: 'value',
              value2: 'value2',
            },
          },
        ],
      },
      pieData: [],
    }
  },
  created() {
    this.getElderAgeData(this.cid)
    this.getCheckElderAgeStatistics(this.cid)
  },
  beforeDestroy() {
    if (this.pieInterval) {
      clearInterval(this.pieInterval)
      this.pieInterval = null
    }
  },
  methods: {
    toElderDetail(data) {
      if (data == '体检') {
        PubSub.publish('isTJ', {
          keyWord: '1',
          data:'体检总人数',
          visible: true
        })
      } else if (data == '高血压') {
        PubSub.publish('isGXY', {
          keyWord: '1',
          data:'高血压人数',
          visible: true
        })
      } else if (data == '高血糖') {
        PubSub.publish('isGXT', {
          keyWord: '1',
          data:'高血糖人数',
          visible: true
        })
      } else if (data == '第一类人数') {
        PubSub.publish('DYL', {
          keyWord: '0',
          data:'第一类人数',
          visible: true
        })
      } else if (data == '第二类人数') {
        PubSub.publish('DEL', {
          keyWord: '1',
          data:'第二类人数',
          visible: true
        })
      }else if (data == '第三类人数') {
        PubSub.publish('DSL', {
          keyWord: '2',
          data:'第三类人数',
          visible: true
        })
      }else if (data == '第四类人数') {
        PubSub.publish('DSIL', {
          keyWord: '3',
          data:'第四类人数',
          visible: true
        })
      }else if (data == '第五类人数') {
        PubSub.publish('DWL', {
          keyWord: '4',
          data:'第五类人数',
          visible: true
        })
      }else if (data == '第六类人数') {
        PubSub.publish('DLL', {
          keyWord: '5',
          data:'第六类人数',
          visible: true
        })
      }
    },
    onMouseOver() {
      if (this.pieInterval) {
        this.chart.dispatchAction({
          type: 'downplay',
          seriesIndex: 0,
          dataIndex: this.dataIndex,
        })
        clearInterval(this.pieInterval)
        this.pieInterval = null
      }
    },
    onGlobalOut() {
      !this.pieInterval && this.startAnimation()
    },
    startAnimation() {
      const dataLen = this.pieData.length
      if (dataLen > 1) {
        this.pieInterval = setInterval(() => {
          this.chart.dispatchAction({
            type: 'downplay',
            seriesIndex: 0,
            dataIndex: this.dataIndex,
          })
          if (this.dataIndex < dataLen - 1) {
            this.dataIndex++
          } else {
            this.dataIndex = 0
          }
          this.chart.dispatchAction({
            type: 'highlight',
            seriesIndex: 0,
            dataIndex: this.dataIndex,
          })
        }, 3000)
      }
    },
    getCheckElderAgeStatistics(cid) {
      this.$api
        .getCheckElderAgeStatistics(cid)
        .then((data) => {
          if (!data || !data.length) return
          this.pieData = data
        })
        .catch((error) => {
          console.error(error)
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.v-view {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  padding: 0px !important;
}

.cv-chart {
  width: 150px !important;
  height: calc(100% - 5vh) !important;
  margin-top: 5vh;
}

.health div {
  color: #fff;
  font-size: 16px !important;
}

.health {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}


.health span {
  background: -webkit-linear-gradient(#ed9f9f, #eb2d2d);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 20px;
  font-weight: bold;
  font-family: "pmzd";
}

.health .sec-title {
  // position: absolute;
  // width: 170px;
  right: 0px;
  top: 0px;
  font-family: "pmzd";
  font-style: italic;
  letter-spacing: 2px;
  font-size: 22px!important;
  color: #39e9ff;
  position: absolute;
  top: 0px;
  width: 100%;
  height: 5vh;
  line-height: 5vh;
}

.chart-view {
  position: relative;
}

.health {
  position: relative;
  // position: absolute;
  // right: 0px;
  // top: 5vh;
  // height: calc(100% - 5vh);
  
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 10px 0px;
  padding-top: 6vh;
  // padding-right: 10px;
  z-index: 99;

 div {
    height: 30px;
    line-height: 30px;
    font-size: 20px;
    cursor: pointer;
  }
}
</style>
